import styled from "styled-components";

export const Container = styled.div`
  max-width: 1120px;
  margin: 0 auto;

  @media (max-width: 1080px) {
    margin: 0px 25px;
}

  h1, h2, h3, h4, h5, h6 {
    color: var(--red);
    text-align: center;
  }
  
  div {
    margin: 15px 0px;
  }

  button {
    color: #fff;
    background-color: var(--red);
    border: 0;
    padding: 0 2rem;
    border-radius: 0.25rem;
    height: 3rem;
    transition: filter 0.2s;
    &:hover {
      filter: brightness(0.9);
    }
  }
`;

export const DivCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;


